const stock = {
    jpath: ['stock'],
    getEmpty() {
        return {};
    },
};
export default stock;
//# sourceMappingURL=stock.js.map